<style lang="less" scoped></style>
<template>
  <Modal
    v-model="show"
    persistent="true"
    dynamic-height
    title="薪资明细"
    max-width="1000"
    width="900"
    :loading="loading"
    @ok="handleOk"
  >
    <div>
      <Table
        ref="table"
        :row-class-name="rowClassName"
        :columns="record_columns"
        :data="records"
        :loading="loading"
        no-data-text="暂无数据"
        size="small"
      />
    </div>
  </Modal>
</template>
<script>
  // import Util, { getsafe } from '../../libs/util';
  import Util from '../../libs/util';
  import Modal from "@/vuetify_custom/v-modal_v1";

  export default {
    name: "MyInformalWageRecordModal",
    components: {
      Modal,
    },
    props: {
      is_reissue: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        show: false,
        loading: false,
        records: [],
        attendance_list_hash: {},
        attendance_leader_id: null,
        team_id: null,
        record_id: null,
      };
    },
    computed: {
      cur_customer() { 
        return this.$store.state.cur_customer;
      },
      record_columns() {
        return [
          {
            title: 'leader',
            key: 'director',
            align: 'center',
            width: 80,
            fixed: 'left',
          },
          {
            title: '团队',
            key: 'team_name',
            align: 'center',
            width: 80,
            fixed: 'left',
          },
          {
            title: '税前日薪',
            key: 'daily_wage',
            align: 'center',
            width: 60,
            
          },
          {
            title: '每日餐补',
            key: 'daily_subsidy',
            align: 'center',
            width: 80,
          },
          {
            //   title: '计薪天数（远程+现场）',
            renderHeader(h) {
              return h('div', {}, [h('div', {}, '计薪天数'), h('div', {}, '（远程+现场）')])
            },
            key: 'work_days',
            align: 'center',
            width: 100,
            render: this.daysRender({dis_key:'work_days' })
          },
          {
            title: '餐补天数',
            key: 'subsidy_days',
            align: 'center',
            width: 90,
            render: this.daysRender({dis_key:'subsidy_days'})
          },
          {
            title: '奖金(￥)',
            key: 'bonus',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              if (!this.canEdit(params) || params.row.dimission) {
                ret.push(h('span', ' ' + this.$util.formatPrice(params.row.bonus)));
              } else {
                ret.push(h('input', {
                  attrs: {
                    type: 'number',
                    size: 'small',
                  },
                  style: {
                    width: '80px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.bonus
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].bonus = event.target.value * 1;
                      this.saveRecords(params.index);
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          },
          {
            title: '提成(￥)',
            key: 'commission',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              if (!this.canEdit(params) || params.row.dimission) {
                ret.push(h('span', ' ' + this.$util.formatPrice(params.row.commission)));
              } else {
                ret.push(h('input', {
                  attrs: {
                    type: 'number',
                    size: 'small',
                  },
                  style: {
                    width: '80px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.commission
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].commission = event.target.value * 1;
                      this.saveRecords(params.index);
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          },
          {
            title: '扣除(￥)',
            key: 'deductions',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              if (!this.canEdit(params) || params.row.dimission) {
                ret.push(h('span', ' ' + this.$util.formatPrice(params.row.deductions)));
              } else {
                ret.push(h('input', {
                  attrs: {
                    type: 'number',
                    size: 'small',
                  },
                  style: {
                    width: '80px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.deductions
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].deductions = event.target.value * 1;
                      this.saveRecords(params.index);
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          },
          {
            renderHeader:(h) => {
              return h('span', ['其他发放(￥)', h('Tooltip', {
                props: {
                  content:"填写前请补充备注！",
                  placement:"top"
                }
              }, [h('Icon', {
                props: {
                  type:'md-help-circle',
                  size:14
                }
              })])])
            },
            title: '其他发放(￥)',
            key: 'other_bonus',
            align: 'center',
            width: 120,
            render: (h, params) => {
              const ret = [];
              if (!this.canEdit(params) || params.row.dimission) {
                ret.push(h('span', ' ' + this.$util.formatPrice(params.row.other_bonus)));
              } else {
                ret.push(h('input', {
                  attrs: {
                    type: 'number',
                    size: 'small',
                  },
                  style: {
                    width: '80px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.other_bonus
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].other_bonus = event.target.value * 1;
                      this.saveRecords(params.index);
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          },
          {
            title: '税前工资',
            key: 'total_wage',
            align: 'center',
            width: 80,
            render: (h, params) => {
              return h('span', '￥' + this.$util.formatDecimal(params.row.pre_tax_wage));
            }
          },
          {
            title: "备注",
            key: 'desc',
            width: 180,
            align: 'left',
            render: (h, params) => {
              const ret = [];
              if (!this.canEdit(params) || params.row.dimission) {
                ret.push(h('span', ' ' + params.row.desc));
              } else {
                ret.push(h('input', {
                  attrs: {
                    size: 'small',
                  },
                  style: {
                    width: '150px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.desc
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].desc = event.target.value;
                      this.saveRecords(params.index);
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          }
        ]
      }
    },
    watch: {},
    methods: {
      rowClassName(row) {
        // 废弃
        if (row.status === 7) {
          return 'color-error';
        }
        return '';
      },
      formatAttendanceNumber(value) {
        if (value && typeof value.toNumber === 'function') {
          return value.toNumber()
        }
        if (value && value.mathjs === 'BigNumber') {
          return Number(value.value) || 0
        }
        return Number(value) || 0
      },
      getCurrentLeaderSalaryList(attendance) {
        const leader_id = this.attendance_leader_id || this.cur_customer && this.cur_customer.id
        if (!attendance || !attendance.salary_list || !leader_id) {
          return attendance && attendance.salary_list && attendance.salary_list.length === 1 ? attendance.salary_list : []
        }
        const matched = attendance.salary_list.filter(salary => {
          return Number(salary.count_leader_id) === Number(leader_id)
        })
        if (!matched.length && attendance.salary_list.length === 1) {
          return attendance.salary_list
        }
        return matched
      },
      getCurrentLeaderSalary(attendance, root_team_id) {
        return this.getCurrentLeaderSalaryList(attendance).find(salary => {
          return Number(salary.root_team_id) === Number(root_team_id)
        })
      },
      edit(record, attendance, options = {}) {
        const id = record.id
        const customer = options.customer || options
        this.show = true;
        this.attendance_list_hash = attendance;
        this.attendance_leader_id = options.leader_id || record.director_id || customer.id;
        this.team_id = customer.root_team_id;
        this.record_id = id;
        const attendanceItem = attendance[record.customer_id]
        const requests = []
        this.loading = true
        // 遍历所有的团队
        this.getCurrentLeaderSalaryList(attendanceItem).forEach(
          salary => {
            // 没有则添加
            requests.push(this.addRecord(id, salary.root_team_id));
          }
        )
        Promise.all(requests).finally(
          () => {
            this.loading = false
          }
        )
      },
      refreshList(id) {
        if (!this.record_id && !id) return Promise.resolve([]);
        return Util.ajax.get(Util.api.informal_wage_topic_record_detail_list, {
          params: {
            record_id: id || this.record_id
          }
        }).then((response) => {
          this.records = response.data.data;
          return response.data.data;
        }).finally(() => {
          this.$emit("refresh");
        });
      },
      addRecord(id, team_id) {
        return Util.ajax.post(Util.api.informal_wage_topic_record_detail_add, {
          id: id,
          team_id: team_id,
          root_team_id: team_id,
        }).then((response) => {
          console.log(response)
          if (response.data.code !== 1) {
            this.$Message.error(response.data.message);
            return;
          }
          const customer_id = response.data.data.customer_id
          // 初始化考勤数据
          const query = {
            detail_id: response.data.data.id,
            should_clock_day: response.data.data.should_clock_day || 0, // 应打卡天数
            work_days: response.data.data.work_days || 0, // 计薪天数
            subsidy_days: response.data.data.subsidy_days || 0, // 餐补天数
            bonus: response.data.data.bonus || 0, // 奖金
            commission: response.data.data.commission || 0, // 提成
            deductions: response.data.data.deductions || 0, // 扣除
            other_bonus: response.data.data.other_bonus || 0, // 其他发放
            desc: response.data.data.desc || "", // 备注
          }
          const attendance = this.attendance_list_hash[customer_id]
          if (attendance) {
            console.log('salary_list', attendance.salary_list)
            const root_team_id = response.data.data.root_team_id || response.data.data.team_id
            const salary = this.getCurrentLeaderSalary(attendance, root_team_id)
            if (salary) {
              const detail = salary.detail || {}
              query.subsidy_days = this.formatAttendanceNumber(detail.meal_subsidy_days)
              query.work_days = this.formatAttendanceNumber(detail.wage_days)
              query.should_clock_days = this.formatAttendanceNumber(detail.should_clock_days)
            }
          }
          console.log("更新明细", query);
          return Util.ajax.post(Util.api.informal_wage_topic_record_detail_update, query)
        }).then(() => {
          this.refreshList();
        })
      },
      handleOk() {
        this.show = false;
      },
      canEdit(params) {
        return params.row.director_id === this.cur_customer.id
      },
      saveRecords(index) {
        const record = this.records[index]
        // 寻找当前用户条目
        const query = {
          detail_id: record.id,
          should_clock_day: record.should_clock_day, // 应打卡天数
          work_days: record.work_days, // 计薪天数
          subsidy_days: record.subsidy_days, // 餐补天数
          bonus: record.bonus, // 奖金
          commission: record.commission, // 提成
          deductions: record.deductions, // 扣除
          other_bonus: record.other_bonus, // 其他发放
          desc: record.desc, // 备注
        }
        return Util.ajax.post(Util.api.informal_wage_topic_record_detail_update, query).then(() => {
          this.refreshList()
        })
      },
      daysRender({dis_key, input_key = dis_key}) {
        return (h, params) => {
          if (this.is_reissue && this.canEdit(params)) {
            return h('input', {
              attrs: {
                type: 'number',
                size: 'small',
                min: '0',
                max: '31',
                value: params.row[dis_key]
              },
              'class': {
                'input-form': true,
              },
              on: {
                blur: (event) => {
                  const days = event.target.value * 1;
                  this.records[params.index][input_key] = days;
                  this.saveRecords(params.index);
                },
                mousewheel: (event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  return false;
                }
              }
            })
          }
          return h('div', this.$util.formatDecimal(params.row[dis_key]));
        }
      },
    },
  };

</script>
